import {
  ACTION_QUERY_COUNTRY_LIST_LOADING,
  ACTION_QUERY_COUNTRY_LIST_ERROR,
  ACTION_QUERY_COUNTRY_LIST_LOADED
} from '../constants'

export default (state = {
  data: [],
  loading: false,
  error: null
}, {type, payload}) => {
  if (type === ACTION_QUERY_COUNTRY_LIST_LOADED) {
    return {
      data: payload,
      loading: false,
      error: null
    }
  }

  if (type === ACTION_QUERY_COUNTRY_LIST_LOADING) {
    return {
      data: [],
      loading: true,
      error: null
    }
  }

  if (type === ACTION_QUERY_COUNTRY_LIST_ERROR) {
    return {
      data: [],
      loading: false,
      error: op.get(payload, 'xhr.response', payload)
    }
  }

  return state
}



// WEBPACK FOOTER //
// ./src/store/countriesReducer.js